export default "/images/vendor/flag-icons/flags/1x1/ma.svg?4d3a6f5c2bd6a436e6a1b03b246336a5";